import { ArrowRight, MapPin } from "lucide-react";
import { IMAGES } from "@/lib/constants";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden text-white"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Lake District fells"
          className="w-full h-full object-cover ken-burns"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(92,86,84,0.55) 0%, rgba(42,39,38,0.45) 40%, rgba(42,39,38,0.85) 100%)",
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-40 md:pt-48 pb-24 md:pb-32 min-h-[100svh] flex flex-col justify-end">
        <div className="reveal">
          <div className="flex items-center gap-2 mb-6">
            <MapPin size={14} className="text-[#3FB6B2]" />
            <span className="text-[11px] tracking-[0.25em] uppercase font-semibold text-[#3FB6B2]">
              Lancashire · Lake District
            </span>
          </div>
        </div>

        <h1
          className="reveal reveal-delay-1 max-w-5xl text-white font-light leading-[1.02] text-5xl sm:text-6xl lg:text-7xl xl:text-8xl tracking-tight"
          style={{ fontFamily: "Outfit, sans-serif" }}
          data-testid="hero-heading"
        >
          Real rock.
          <br />
          <span className="italic font-extralight">Real mountains.</span>{" "}
          <span style={{ color: "#3FB6B2" }}>Real instruction.</span>
        </h1>

        <p
          className="reveal reveal-delay-2 mt-8 max-w-xl text-white/85 text-lg leading-relaxed"
          data-testid="hero-subheading"
        >
          Climbing courses, group abseils and private coaching delivered on the
          finest crags of the English fells — by qualified instructors who live
          and breathe these hills.
        </p>

        <div className="reveal reveal-delay-3 mt-10 flex flex-col sm:flex-row gap-4">
          <a
            href="#book"
            className="btn-primary"
            data-testid="hero-book-button"
          >
            Book a session <ArrowRight size={18} />
          </a>
          <a
            href="#services"
            className="btn-ghost-light"
            data-testid="hero-services-button"
          >
            Explore courses
          </a>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-6 right-6 md:right-12 z-10 hidden md:flex items-center gap-3 text-white/70 text-xs tracking-[0.25em] uppercase">
        Scroll
        <div className="w-12 h-px bg-white/40" />
      </div>
    </section>
  );
}
